import { useSignups } from "Signups/state";

export function useIsSignedUpForAnyItem() {
  const [state] = useSignups();

  return isSignedUpForAnyItem(state.userSignupItems);
}

// this can be used in sitations where a custom hook can't be used
export function isSignedUpForAnyItem(userSignupItems) {
  try {
    if (!userSignupItems) return false;

    let signupsFound = false;
    Object.keys(userSignupItems).forEach((id) => {
      if (userSignupItems[id].count > 0) {
        signupsFound = true;
      }
    });

    return signupsFound;
  } catch (err) {
    console.log("error:", err);
    return false;
  }
}
